import { render, staticRenderFns } from "./TableWS.vue?vue&type=template&id=3e7a2543&"
import script from "./TableWS.vue?vue&type=script&lang=ts&"
export * from "./TableWS.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports